import React from 'react';

import { IntegrationUsageLogsPageWrapper } from 'src/components/apiIntegrations';
import { PageLayout } from 'src/components/common';
import { pageLayoutPaperSx } from 'src/constants/styles';
import { TableDataProvider } from 'src/providers/TableDataProvider';

export const IntegrationUsageLogsPage: React.FC = () => (
  <PageLayout titleContent="API & Integrations" paperSx={pageLayoutPaperSx}>
    <TableDataProvider>
      <IntegrationUsageLogsPageWrapper />
    </TableDataProvider>
  </PageLayout>
);
